export default "__VITE_ASSET__DHc_6QVZ__"